import { render, staticRenderFns } from "./CancelApproval.vue?vue&type=template&id=246f6962"
import script from "./CancelApproval.vue?vue&type=script&lang=js"
export * from "./CancelApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports